'use strict';
(() => {
  if(window.IdolnestDrawerMotion)return;
  const states=new WeakMap(),active=new Set(),reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const preset=()=>document.querySelector('idolnest-navigation')?.dataset.drawerMotionPreset||'smooth';
  const timings=()=>{const value=preset();return reduced.matches||value==='none'?{enter:0,exit:0}:value==='quick'?{enter:250,exit:160}:{enter:340,exit:210};};
  function stopAnimations(state){
    clearTimeout(state.timer);
    state.animations.forEach(animation=>animation.cancel());
    state.animations=[];
    active.delete(state);
  }
  function interrupt(state){
    state.generation++;
    stopAnimations(state);
    if(state.resolveClose)state.resolveClose(false);
    state.resolveClose=null;
    state.closePromise=null;
  }
  function cleanup(state){
    state.generation++;
    stopAnimations(state);
    state.phase='closed';
    delete state.dialog.dataset.inDrawerPhase;
    if(state.resolveClose)state.resolveClose(true);
    state.resolveClose=null;
    state.closePromise=null;
  }
  function getState(dialog){
    let state=states.get(dialog);
    if(state)return state;
    state={dialog,side:'right',phase:'closed',generation:0,animations:[],timer:0,resolveClose:null,closePromise:null};
    states.set(dialog,state);
    dialog.addEventListener('cancel',event=>{if(dialog.open&&dialog.hasAttribute('data-in-drawer-motion')){event.preventDefault();close(dialog);}});
    dialog.addEventListener('close',()=>{if(!dialog.open)cleanup(state);});
    return state;
  }
  function finish(state,token){
    if(state.generation!==token)return;
    if(state.phase==='closing'){
      stopAnimations(state);
      if(state.dialog.open)state.dialog.close();else cleanup(state);
    }else if(state.phase==='opening'){
      stopAnimations(state);
      state.phase='open';
      state.dialog.dataset.inDrawerPhase='open';
    }
  }
  function run(state,frames,duration,entering){
    const token=state.generation,dialog=state.dialog;
    if(!duration||typeof dialog.animate!=='function'){finish(state,token);return;}
    active.add(state);
    const panel=dialog.animate(frames,{duration,easing:entering?'cubic-bezier(.22,.8,.24,1)':'cubic-bezier(.4,0,.8,.4)',fill:'both'});
    state.animations.push(panel);
    if(entering){
      const selector=dialog.id==='InNavigationDialog'?'.in-nav-scroll':'.in-cart-items,.in-cart-footer';
      dialog.querySelectorAll(selector).forEach((element,index)=>{
        const animation=element.animate([{opacity:.6,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:Math.min(260,duration-80),delay:30+index*20,easing:'cubic-bezier(.22,.8,.24,1)',fill:'both'});
        state.animations.push(animation);
      });
    }
    Promise.all(state.animations.map(animation=>animation.finished)).then(()=>finish(state,token),()=>{});
    state.timer=setTimeout(()=>finish(state,token),duration+100);
  }
  function open(dialog,side='right'){
    const state=getState(dialog);
    if(dialog.open&&state.phase!=='closing')return false;
    const reversing=dialog.open;
    const current=reversing?getComputedStyle(dialog).transform:null;
    interrupt(state);
    state.side=side;
    state.phase='opening';
    dialog.dataset.inDrawerMotion='true';
    dialog.dataset.inDrawerPhase='opening';
    const duration=timings().enter;
    dialog.toggleAttribute('data-in-drawer-instant',!duration);
    if(!dialog.open)dialog.showModal();
    const from=current&&current!=='none'?current:`translate3d(${side==='left'?'-':''}100%,0,0)`;
    run(state,[{transform:from},{transform:'translate3d(0,0,0)'}],duration,true);
    return true;
  }
  function close(dialog,immediate=false){
    const state=getState(dialog);
    if(!dialog.open){cleanup(state);return Promise.resolve(true);}
    if(state.phase==='closing'){
      const pending=state.closePromise;
      if(immediate)finish(state,state.generation);
      return pending;
    }
    const current=getComputedStyle(dialog).transform;
    interrupt(state);
    state.phase='closing';
    state.closePromise=new Promise(resolve=>state.resolveClose=resolve);
    const pending=state.closePromise;
    dialog.dataset.inDrawerPhase='closing';
    dialog.dispatchEvent(new CustomEvent('idolnest:drawer:closing'));
    const duration=immediate?0:timings().exit;
    dialog.toggleAttribute('data-in-drawer-instant',!duration);
    run(state,[{transform:current==='none'?'translate3d(0,0,0)':current},{transform:`translate3d(${state.side==='left'?'-':''}100%,0,0)`}],duration,false);
    return pending;
  }
  function dispose(dialog){
    const state=states.get(dialog);
    if(state){interrupt(state);state.phase='closed';delete dialog.dataset.inDrawerPhase;}
    delete dialog.dataset.inDrawerMotion;
    dialog.removeAttribute('data-in-drawer-instant');
    if(dialog.open)dialog.close();
  }
  function finishActive(){for(const state of Array.from(active))finish(state,state.generation);}
  reduced.addEventListener('change',()=>{if(reduced.matches)finishActive();});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)finishActive();});
  window.addEventListener('pagehide',finishActive);
  window.IdolnestDrawerMotion={open,close,dispose,isClosing:dialog=>states.get(dialog)?.phase==='closing'};
})();
